import parse from 'utils/parse';
import type { ResponsiveImageOutput } from 'contracts';

import ASMR from './assets/asmr.jpg';
import Cosplay from './assets/cosplay.jpg';
import Fetish from './assets/fetish.jpg';
import Flirting from './assets/flirting.jpg';
import NoFace from './assets/no-face.jpg';
import PublicPlaces from './assets/public-places.jpg';
import messages from './category-banner.i18n';

const makeTestId = (...ids: string[]): string => parse.toTestId('category-banner', ...ids);

const testId = Object.freeze({
  component: makeTestId(),
});

const translations = messages.pages.landing.categoryBanner.livejasmin;

const banner1 = [
  {
    src: PublicPlaces as ResponsiveImageOutput,
    category: translations.publicPlaces,
    name: 'LeiaMure',
    nameVariant: 'dark',
  },
  {
    src: Flirting as ResponsiveImageOutput,
    category: translations.flirting,
    name: 'Chloe',
    nameVariant: 'light',
  },
  {
    src: Fetish as ResponsiveImageOutput,
    category: translations.fetish,
    name: 'KayaVega',
    nameVariant: 'light',
  },
];

const banner2 = [
  {
    src: ASMR as ResponsiveImageOutput,
    category: translations.asmr,
    name: 'AmyCruize',
    nameVariant: 'light',
  },
  {
    src: NoFace as ResponsiveImageOutput,
    category: translations.noFace,
    name: 'SophieRhyder',
    nameVariant: 'light',
  },
  {
    src: Cosplay as ResponsiveImageOutput,
    category: translations.cosplay,
    name: 'KateGale',
    nameVariant: 'light',
  },
];

export { testId, banner1, banner2 };
